import { io } from "socket.io-client";

const SOCKET_URL = `${process.env.REACT_APP_SOCET_API}`; 
// Replace with your server URL

const socket = io(SOCKET_URL, {
  autoConnect: false, 
  // You can set this to true if you want to connect automatically
});

export default socket;
